export default function getDate(date) {
    if (!date) return null

    if (date.type === 'offset') {
        const today = new Date()
        const result = new Date(today) // Создаем копию
        console.log("CURRENT DATE", date)
        if (date.length === "") {
            console.log("Invalid date")
            return null
        }
        // Определяем направление смещения
        const multiplier = date.offsetOperation?.type === 'MINUS' ? -1 : 1

        if (date.offsetName?.type === 'MONTH') {
            result.setMonth(result.getMonth() + (date.length * multiplier))
            return result
        }
        if (date.offsetName?.type === 'DAY') {
            result.setDate(result.getDate() + (date.length * multiplier))
            return result
        }
    }

    if (date.type === 'exact') {
        return date.date ? new Date(date.date) : null
    }

    return null
}